import { Injectable } from "@angular/core";
import { Account } from "../entity/Account";
import { PackageData } from "../obj/PackageData";

@Injectable({
    providedIn: "root"
})
export class CacheService {
    private packages: { [key: number]: PackageData[] };

    constructor() {
        this.packages = {};
    }

    addPackagesToCache(account: Account, pkg: PackageData[]): void {
        this.packages[account.id] = pkg;
    }

    getPackagesFromCache(account: Account): PackageData[] | null {
        return this.packages[account.id];
    }

    clearPackagesFromCache(account: Account): void {
        if (account == null) {
            return;
        }
        delete this.packages[account.id];
    }

}